"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
const utils_1 = require("../utils");
// Define the dynamic variants for the button
const buttonVariants = (0, class_variance_authority_1.cva)("inline-flex items-center justify-center font-normal transition relative overflow-hidden z-[1] border-[1px] text-center cursor-pointer before:content-[''] before:absolute before:inset-0 before:w-[150%] before:h-full before:transform before:translate-x-[-120%] before:skew-x-[-35deg] before:origin-[0_0] before:transition-transform before:duration-[1s] before:ease-[cubic-bezier(0.07,0.51,0.12,1)] before:z-[-1] hover:before:translate-x-0 focus:before:translate-x-0", {
    variants: {
        variant: {
            primary: "bg-brandSecondary before:bg-white text-white border-brandSecondary hover:border-brandSecondary focus:border-brandSecondary hover:bg-brandSecondary focus:bg-brandSecondary hover:text-brandSecondary focus:text-brandSecondary",
            secondary: "bg-neutral200 before:bg-white text-black border-neutral200 hover:border-neutral200 hover:bg-neutral200 hover:text-black focus:border-neutral200 focus:bg-white focus:text-black",
            outline: "bg-white before:bg-brandSecondary text-black border-grey300 hover:border-brandSecondary focus:border-brandSecondary hover:bg-white focus:bg-brandSecondary hover:text-white focus:text-white",
            danger: "bg-red before:bg-white text-white border-red hover:border-red focus:border-red hover:bg-red focus:bg-brandSecondary hover:text-red focus:text-red",
            voila: "bg-voila before:bg-white text-grey700 border-voila hover:border-voila focus:border-voila hover:bg-voila focus:bg-voila hover:text-voila focus:text-red",
            icon: "border-none"
        },
        size: {
            small: "text-sm px-3 py-1.5",
            medium: "text-base px-4 py-2",
            large: "text-lg px-6 py-3",
            none: "",
        },
        rounded: {
            none: "rounded-none",
            sm: "rounded-sm",
            md: "rounded-md",
            lg: "rounded-lg",
            full: "rounded-full",
        },
        disabled: {
            true: "cursor-not-allowed opacity-50 text-black bg-grey300 border-grey300 hover:border-grey300 before:bg-grey300 hover:bg-grey300",
            false: "",
        },
    },
    defaultVariants: {
        variant: "primary",
        size: "medium",
        rounded: "full",
        disabled: false,
    },
});
/**
 * Button component with hover effect and rounded corners.
 *
 * @param {ButtonProps} props - Props for the button.
 * @returns {JSX.Element} The rendered Button component.
 */
const Button = ({ className, variant, size, rounded, disabled = false, asChild, children, ...props }) => {
    if (asChild && react_1.default.isValidElement(children)) {
        // Narrow down the child element
        const child = children;
        // Pass `disabled` only when the element supports it
        const filteredProps = {
            ...props,
            className: (0, utils_1.cn)(buttonVariants({ variant, size, rounded, disabled }), child.props.className // Merge child className
            ),
            ...(child.type === "button" && { disabled }), // Apply only if the child is a <button>
        };
        return react_1.default.cloneElement(child, filteredProps);
    }
    return (react_1.default.createElement("button", { className: (0, utils_1.cn)(buttonVariants({ variant, size, rounded, disabled }), className), disabled: disabled, ...props }, children));
};
exports.Button = Button;
